import React from 'react';
import './EvidenceModal.css';

function EvidenceModal({ isOpen, onClose, evidence }) {
  if (!isOpen) return null;

  const asset =
    evidence?.asset ||
    evidence?.asset_label ||
    evidence?.asset_identifier ||
    'N/A';

  const detected =
    evidence?.detected_at ||
    evidence?.first_seen ||
    evidence?.timestamp ||
    'N/A';

  let proof =
    evidence?.proof ||
    evidence?.evidence_pointer ||
    evidence?.summary ||
    'Non-exploit confirmation available.';

  // If evidence_pointer is a JSON string, try to pretty-print it
  if (typeof proof === 'string') {
    try {
      const parsed = JSON.parse(proof);
      if (parsed && typeof parsed === 'object') {
        proof = JSON.stringify(parsed, null, 2);
      }
    } catch {
      // leave proof as-is if not valid JSON
    }
  }

  return (
    <div className="evidence-modal-overlay" role="dialog" aria-modal="true">
      <div className="evidence-modal">
        <div className="evidence-modal-header">
          <h3>Evidence Summary</h3>
          <button type="button" className="evidence-modal-close" onClick={onClose}>
            Close
          </button>
        </div>
        <div className="evidence-modal-body">
          <div className="evidence-item">
            <span className="evidence-label">Asset</span>
            <span>{asset}</span>
          </div>
          <div className="evidence-item">
            <span className="evidence-label">Detected</span>
            <span>{detected}</span>
          </div>
          <div className="evidence-item">
            <span className="evidence-label">Proof</span>
            <pre className="evidence-proof">{proof}</pre>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EvidenceModal;
